/**
 * Global network error state so we can surface fetch failures to the error boundary.
 * When any API call fails due to network (e.g. no internet), we set this and
 * NetworkErrorTrigger throws in render so the boundary can show.
 */

let globalNetworkError = null;
const listeners = new Set();

function isNetworkError(err) {
  const msg = (err?.message || "").toLowerCase();
  return (
    msg.includes("failed to fetch") ||
    msg.includes("network error") ||
    msg.includes("load failed") ||
    msg.includes("network request failed")
  );
}

export function setGlobalNetworkError(err) {
  if (!err || !isNetworkError(err)) return;
  globalNetworkError = err;
  listeners.forEach((cb) => cb(err));
}

export function getGlobalNetworkError() {
  return globalNetworkError;
}

export function clearGlobalNetworkError() {
  globalNetworkError = null;
  listeners.forEach((cb) => cb(null));
}

export function subscribeGlobalNetworkError(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}
